(function () {
    'use strict';

    angular.module('thankview.global')
        .controller('HeaderController', ['$scope', '$rootScope', '$window', '$document', function ($scope, $rootScope, $window, $document) {
            var preloginHeader;

            $scope.init = function () {
                // if this is a transparent header, setup scroll listener
                preloginHeader = $document[0].querySelector('#site-header.transparent');
                if (preloginHeader) {
                    preloginHeader = angular.element(preloginHeader);
                    angular.element($window).on('scroll', $scope.scroll);
                    $scope.scroll();
                }

                $scope.setCurrentPage();
            };

            $scope.scroll = function () {
                // number of pixels to scroll page before changing background color
                var scrollY = 15;

                if ($window.pageYOffset > scrollY && preloginHeader.hasClass('transparent')) {
                    preloginHeader.removeClass('transparent');
                } else if ($window.pageYOffset <= scrollY && !preloginHeader.hasClass('transparent')) {
                    preloginHeader.addClass('transparent');
                }
            };

            $scope.openSeeExample = function ($event) {
                if ($event) $event.preventDefault();

                $scope.forceCloseMenu();

                $rootScope.$broadcast('open-see-example');

                if (config.localStorage) {
                    $window.localStorage.setItem('homepage-popup', true);
                }
            };

            $scope.setCurrentPage = function () {
                var paths = $window.location.pathname.split('/');
                if (paths[1] && paths[1] === 'account') {
                    if (paths[2] && paths[2] === 'settings') {
                        $rootScope.currentPageName = paths[3] ? paths[3] : '';
                    } else {
                        $rootScope.currentPageName = paths[2] ? paths[2] : '';
                    }
                } else {
                    $rootScope.currentPageName = paths[1] ? paths[1] : '';
                }
            };

            $scope.toggleMenu = function ($event) {
                if (!$event) {
                    return;
                }

                var m = $document[0].querySelector('#main-nav');
                if (m) {
                    angular.element(m).toggleClass('open');
                    var b = $document[0].getElementsByTagName('body')[0];
                    angular.element(b).toggleClass('nav-open');
                    $event.target.blur();
                }
            };

            $scope.forceCloseMenu = function () {
                var m = $document[0].querySelector('#main-nav');
                angular.element(m).removeClass('open');
                var b = $document[0].getElementsByTagName('body')[0];
                angular.element(b).removeClass('nav-open');
            };

            $scope.menuToggled = function (open) {
                // broadcast menu toggled event with open value
                if (!open) {
                    $rootScope.$broadcast('exit-submenus');
                }
            };

            $scope.init();
        }]);
}());
